import { render, staticRenderFns } from "./RightBox.vue?vue&type=template&id=d3905e02&scoped=true&"
import script from "./RightBox.vue?vue&type=script&lang=js&"
export * from "./RightBox.vue?vue&type=script&lang=js&"
import style0 from "./RightBox.vue?vue&type=style&index=0&id=d3905e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3905e02",
  null
  
)

export default component.exports